import {
  HeadingTitle,
  HighLightWrapper,
  HighlightLink,
  ImgTitle,
  ParagraphBlock,
  ParagraphInlineTitle,
  ParagraphTitle,
  SecondHeadingTitle,
  TextBlock,
} from "@/components/Typography";

import { Divider } from "antd";
import TitleImage from "@/components/shared/TitleImage";
import Video from "@/components/shared/Video";
import apopo from "/Img/country/Cambodia/apopo.jpg";
import finishTheRun from "/Img/country/Cambodia/finishTheRun.jpg";
import { handleLangData } from "@/i18n";
import runningVideo from "/Img/country/Cambodia/runningVideo.mp4";
import startTheRun from "/Img/country/Cambodia/startTheRun.jpg";
import temple1 from "/Img/country/Cambodia/temple1.jpeg";
import temple2 from "/Img/country/Cambodia/temple2.jpeg";
import templeBike from "/Img/country/Cambodia/templeBike.jpg";
import templePeople from "/Img/country/Cambodia/templePeople.jpeg";
import templeSunrise from "/Img/country/Cambodia/templeSunrise.jpeg";
import tuktukFamily from "/Img/country/Cambodia/tuktukFamily.jpg";
import tuktukHome from "/Img/country/Cambodia/tuktukHome.jpg";

const HalfMarathonInAngkorWat = (currenLang: string) => {
  const t = handleLangData(currenLang);
  return (
    <>
      <HeadingTitle>{t["cambodia.halfMarathon.reasonTitle"]}</HeadingTitle>
      <ParagraphBlock>{t["cambodia.halfMarathon.reasonP1"]}</ParagraphBlock>

      <HeadingTitle>{t["cambodia.halfMarathon.prepTitle"]}</HeadingTitle>
      <ParagraphBlock>
        {t["cambodia.halfMarathon.prepP1"]}
        <div>
          <HighlightLink
            to="https://worldsmarathons.com/marathon/the-angkor-empire-marathon"
            target="_blank"
            rel="noopener noreferrer"
          >
            Angkor Empire Marathon
          </HighlightLink>
        </div>
      </ParagraphBlock>
      <ParagraphBlock>{t["cambodia.halfMarathon.prepP2"]}</ParagraphBlock>

      <HeadingTitle>{t["cambodia.halfMarathon.raceTitle"]}</HeadingTitle>
      <ParagraphBlock>
        <TitleImage
          src={startTheRun}
          titleImgText={t["cambodia.halfMarathon.img.startRun"]}
        />
        {t["cambodia.halfMarathon.raceP1"]}
        <Video width="400" height={240} controls videoDescription={"Angkor Wat Half Marathon"}>
          <source src={runningVideo} type="video/mp4" />
        </Video>
      </ParagraphBlock>

      <ParagraphBlock>
        <TitleImage
          src={finishTheRun}
          titleImgText={t["cambodia.halfMarathon.img.finishRun"]}
        />
      </ParagraphBlock>

      <ParagraphBlock>{t["cambodia.halfMarathon.conclusionP"]}</ParagraphBlock>
    </>
  );
};

const SiemReapTrip = (currenLang: string) => {
  const t = handleLangData(currenLang);
  return (
    <>
      <ParagraphBlock>
        {t["cambodia.siemReap.introP1"]}
        <HighlightLink to="/Half-Marathon-In-AngKor-Wat">
          {t["cambodia.siemReap.introLinkText"]}
        </HighlightLink>
        {t["cambodia.siemReap.introP2"]}
      </ParagraphBlock>

      <HeadingTitle>{t["cambodia.siemReap.prepTitle"]}</HeadingTitle>
      <ParagraphBlock>
        {t["cambodia.siemReap.prepP"]}
        <HighlightLink
          to="https://yuyi.com.sg/products/9787535668776"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t["cambodia.siemReap.bookLink"]}
        </HighlightLink>
        {t["cambodia.siemReap.prepP2"]}
      </ParagraphBlock>

      <HeadingTitle>{t["cambodia.siemReap.itineraryTitle"]}</HeadingTitle>
      <ParagraphBlock>
        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.day1Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            {t["cambodia.siemReap.day1Intro"]}
            <ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item1"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item2"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item3"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item4"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item5"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day1Item6"]}</ParagraphBlock>
            </ParagraphBlock>
          </ParagraphBlock>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.day2Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            {t["cambodia.siemReap.day2Intro"]}
            <ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day2Item1"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day2Item2"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day2Item3"]}</ParagraphBlock>
              <ParagraphBlock>{t["cambodia.siemReap.day2Item4"]}</ParagraphBlock>
            </ParagraphBlock>
          </ParagraphBlock>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.day3Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            {t["cambodia.siemReap.day3Intro"]}
            <div>
              <HighlightLink
                to="https://apopo.org/support-us/apopo-visitor-center/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t["cambodia.siemReap.apopoLink"]}
              </HighlightLink>
            </div>
          </ParagraphBlock>
          <ParagraphBlock>
            {t["cambodia.siemReap.day3P2"]}
            <div>
              <HighlightLink
                to="https://www.cambodialandminemuseum.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t["cambodia.siemReap.mineMuseumLink"]}
              </HighlightLink>
            </div>
          </ParagraphBlock>
        </ParagraphBlock>

        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.day4Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            {t["cambodia.siemReap.day4P"]}
            <HighlightLink
              to="https://www.klook.com/zh-TW/activity/29603-kampong-phluk-floating-village-tour/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t["cambodia.siemReap.day4P2"]}
            </HighlightLink>
          </ParagraphBlock>
        </ParagraphBlock>

        <HighLightWrapper>{t["cambodia.siemReap.day4Tip"]}</HighLightWrapper>
      </ParagraphBlock>

      <ParagraphBlock>
        <HeadingTitle>{t["cambodia.siemReap.detailTitle"]}</HeadingTitle>
        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.detail.day1Title"]}</SecondHeadingTitle>
          <TitleImage src={temple1} titleImgText={t["cambodia.siemReap.img.temple1"]} />
          {t["cambodia.siemReap.detail.day1P"]}
          <ParagraphBlock>
            <ParagraphTitle>{t["cambodia.siemReap.sunriseTitle"]}</ParagraphTitle>
            <TitleImage src={templeSunrise} titleImgText={t["cambodia.siemReap.img.templeSunrise"]} />
            {t["cambodia.siemReap.sunriseP"]}
          </ParagraphBlock>
          <ParagraphBlock>
            <ParagraphTitle>{t["cambodia.siemReap.muralsTitle"]}</ParagraphTitle>
            <TitleImage src={temple2} titleImgText={t["cambodia.siemReap.img.temple2"]} />
            {t["cambodia.siemReap.muralsP"]}
          </ParagraphBlock>
        </ParagraphBlock>

        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.detail.day2Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            <TitleImage src={templeBike} titleImgText={t["cambodia.siemReap.img.templeBike"]} />
          </ParagraphBlock>
          {t["cambodia.siemReap.detail.day2P"]}
          <ParagraphBlock>
            <TitleImage src={templePeople} />
            {t["cambodia.siemReap.detail.day2Warning"]}
          </ParagraphBlock>
        </ParagraphBlock>

        <ParagraphBlock>
          <SecondHeadingTitle>{t["cambodia.siemReap.detail.day34Title"]}</SecondHeadingTitle>
          <ParagraphBlock>
            <TitleImage src={apopo} titleImgText={t["cambodia.siemReap.img.apopo"]} />
          </ParagraphBlock>
          <ParagraphBlock>{t["cambodia.siemReap.detail.day34P"]}</ParagraphBlock>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["cambodia.siemReap.bonusTitle"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <TitleImage src={tuktukHome} titleImgText={t["cambodia.siemReap.img.tuktukHome"]} />
          {t["cambodia.siemReap.bonusP1"]}
        </ParagraphBlock>
        <ParagraphBlock>{t["cambodia.siemReap.bonusP2"]}</ParagraphBlock>
        <ParagraphBlock>
          {t["cambodia.siemReap.bonusP3"]}
          <TitleImage src={tuktukFamily} titleImgText={t["cambodia.siemReap.img.tuktukFamily"]} />
          {t["cambodia.siemReap.bonusP4"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <HeadingTitle>{t["cambodia.siemReap.conclusionTitle"]}</HeadingTitle>
        <ParagraphBlock>{t["cambodia.siemReap.conclusionP"]}</ParagraphBlock>
      </ParagraphBlock>
    </>
  );
};

const PhnomPenhTrip = (a) => {};

export { HalfMarathonInAngkorWat, SiemReapTrip, PhnomPenhTrip };
